import React from "react";

export default function GoalTracker({ goals = [] }) {
  if (!goals.length) return null;

  return (
    <div className="flex gap-3 overflow-x-auto">
      {goals.map((g) => {
        const pct = g.targetHires > 0 ? Math.round((g.currentHires / g.targetHires) * 100) : 0;
        const statusColor = g.status === "ON_TRACK" ? "#10B981" : g.status === "AT_RISK" ? "#F59E0B" : "#EF4444";
        return (
          <div key={g.id} className="bg-white border border-slate-200 rounded-lg p-3 min-w-[180px] flex-shrink-0">
            <div className="flex items-center gap-2 mb-2">
              <div className="relative w-10 h-10">
                <svg viewBox="0 0 36 36" className="w-full h-full" style={{ transform: "rotate(-90deg)" }}>
                  <circle cx="18" cy="18" r="15" fill="none" stroke="#E2E8F0" strokeWidth="3" />
                  <circle cx="18" cy="18" r="15" fill="none" stroke={statusColor} strokeWidth="3"
                    strokeDasharray={`${pct} 100`} strokeLinecap="round" />
                </svg>
                <div className="absolute inset-0 flex items-center justify-center text-[10px] font-bold" style={{ color: statusColor }}>{pct}%</div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-xs font-medium text-vf-base truncate">{g.department || "Job #" + g.jobId}</div>
                <div className="text-[10px] text-vf-muted">{g.currentHires}/{g.targetHires} hired</div>
              </div>
            </div>
            <div className="flex items-center gap-1">
              <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded-full`}
                style={{ background: statusColor + "15", color: statusColor }}>{g.status?.replace("_", " ")}</span>
              {g.confidencePct && <span className="text-[10px] text-vf-muted">{g.confidencePct}% confidence</span>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
